$(document).ready(function(){
    let scrollPosition = 0;

$('.product-desc-ing-nut__item').on('click', function(event) {
  event.preventDefault();

  // Save the current scroll position
  scrollPosition = $(window).scrollTop();
  
  // Set the body's top position to the negative scroll position
  $('body').css('top', `-${scrollPosition}px`);
  
  // Add the fixed position class
  $('body').addClass('body-has-product-slidein');
  $('#june2024productslidein').addClass('product-slidein-active');
  $('#june2024productslidein').siblings().addClass('product-grid-wrapper-behind');
  
  if($(this).hasClass('product-desc-ing-nut__item-desc')) {
    $('.product-slidein-desc').addClass('si-item-show').siblings().removeClass('si-item-show');
  }

  if($(this).hasClass('product-desc-ing-nut__item-ing')) {
    $('.product-slidein-ingredients').addClass('si-item-show').siblings().removeClass('si-item-show');
  }

  if($(this).hasClass('product-desc-ing-nut__item-nut')) {
    $('.product-slidein-nutritional').addClass('si-item-show').siblings().removeClass('si-item-show');
  }
});

$('.product-slidein-close').on('click', function(e) {
  e.preventDefault();

  // Remove the fixed position class and reset top positioning
  $('body').removeClass('body-has-product-slidein');
  $('body').css('top', '');

  // Restore the scroll position
  window.scrollTo(0, scrollPosition);

  $('#june2024productslidein').removeClass('product-slidein-active');
  $('#june2024productslidein').siblings().removeClass('product-grid-wrapper-behind');
});






  // Get the current page URL without query parameters
    var currentURL = window.location.pathname;

    // Get all the flavor selection links
    $('.product-flavor-selection a').each(function() {
        // Extract the path portion of the href
        var linkURL = $(this).attr('href').split('?')[0];

        // Check if the href matches the current URL
        if (linkURL === currentURL) {
            // Add the 'current-product' class to the link
            $(this).addClass('current-product');
        }
    });

    

});






